<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-circle-plus-outline"
          @click="addClick()"
        >
          新增
        </el-button>
        <!-- <el-button
          type="danger"
          plain
          size="mini"
          icon="el-icon-circle-close"
          @click="delClick"
          :disabled="ids.length == 0 ? true : false"
          >删除</el-button
        > -->
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-top-right"
          @click="exportData()"
          :disabled="tableData.length == 0 ? true : false"
        >
          导出
        </el-button>
        
      </div>
      <div class="search_box">
        <el-input
          v-model.trim="requestData.lectureUserName"
          size="mini"
          clearable
          placeholder="请输入授课人员名称"
        ></el-input>
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchData"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column label="序号" width="70" align="center">
            <template v-slot="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="lectureUserName"
            label="授课人"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="lectureTeacherUnit"
            label="授课单位"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="lectureBeau"
            label="授课对象"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="lectureClass"
            label="授课时长"
            align="center"
          ><template v-slot='scope'>
            {{scope.row.lectureClass}}小时
            </template></el-table-column>
          <el-table-column
            prop="lectureName"
            label="授课名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="lectureContent"
            label="授课内容"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <!-- <template v-slot="scope">
              <el-link
                type="primary"
                @click="editClick(scope.row)"
                :underline="false"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                type="primary"
                @click="delClick(scope.row)"
                :underline="false"
                >删除</el-link
              >
            </template> -->
            <template v-slot="scope">
              <el-link
                type="primary"
                @click="editClick(scope.row)"
                :underline="false"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-dropdown>
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      type="primary"
                      @click="delClick(scope.row)"
                      :underline="false"
                      >删除</el-link
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      type="primary"
                      @click="checkInfo(scope.row)"
                      :underline="false"
                      >查看详情</el-link
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <add-or-edit
      :initialData="initialData"
      :drawerShow="drawerShow"
      :drawerType="drawerType"
      @handleClose="handleClose"
      @saveData="saveData"
    ></add-or-edit>
  </div>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
import addOrEdit from "./components/addOrEdit.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  name: "prelectionRecord",
  components: {
    addOrEdit
  },
  props: {},
  data() {
    //这里存放数据
    return {
      requestData: {
        pageNum: 1,
        pageSize: 20,
        organizationId: this.$store.getters.getUserInfo.schoolId,
        lectureUserName: "",
        type:3
      },
      tableData: [],
      total: 0,
      drawerShow: false,
      drawerType: "add",
      initialData: {
        lectureUserName: "",
        lectureTeacherUnit: "",
        lectureBeau: "",
        lectureClass: "",
        lectureName: "",
        lectureContent: "",
        lectureImages: "",
        lectureFiles: "",
        organizationId: "",
        type:3
      }
    };
  },
  //监控data中的数据变化
  watch: {},
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    searchData() {
      this.requestData.pageNum = 1;
      this.getList();
    },
    addClick() {
      this.drawerShow = true;
      this.drawerType = "add";
      this.initialData = {
        lectureUserName: "",
        lectureTeacherUnit: "",
        lectureBeau: "",
        lectureClass: "",
        lectureName: "",
        lectureContent: "",
        lectureImages: "",
        lectureFiles: "",
        organizationId: this.$store.getters.getUserInfo.schoolId,
        type:3
      };
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getList();
    },
    async getList() {
      let req = Object.assign({}, this.requestData);
      let res = await this.$Http.getLectureRecords(req);
      if (res.code == 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total || 0;
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.tableData = [];
        this.total = 0;
        this.$message({
          type: "error",
          message: "查询失败"
        });
      }
    },
    editClick(info) {
      this.drawerShow = true;
      this.drawerType = "edit";
      this.initialData = {
        lectureUserName: info.lectureUserName,
        lectureTeacherUnit: info.lectureTeacherUnit,
        lectureBeau: info.lectureBeau,
        lectureClass: info.lectureClass,
        lectureName: info.lectureName,
        lectureContent: info.lectureContent,
        lectureImages: info.lectureImages,
        lectureFiles: info.lectureFiles,
        lectureId: info.lectureId,
        type:3
      };
    },
    checkInfo(info){
      this.drawerShow = true;
      this.drawerType = "info";
      this.initialData = {
        lectureUserName: info.lectureUserName,
        lectureTeacherUnit: info.lectureTeacherUnit,
        lectureBeau: info.lectureBeau,
        lectureClass: info.lectureClass,
        lectureName: info.lectureName,
        lectureContent: info.lectureContent,
        lectureImages: info.lectureImages,
        lectureFiles: info.lectureFiles,
        lectureId: info.lectureId,
      };
    },
    delClick(info) {
      this.$confirm("此操作将永久删除此记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        this.delInfo([info.lectureId]);
      });
    },
    async delInfo(ids) {
      let res = await this.$Http.delLectureRecords({ lectureIdList: ids });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.getList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: "删除失败"
        });
      }
    },
    handleClose() {
      this.drawerShow = false;
    },
    saveData(info) {
      if (this.drawerType == "add") {
        this.addInfo(info);
      } else {
        this.editInfo(info);
      }
    },
    async addInfo(info) {
      let req = Object.assign({}, info);
      let res = await this.$Http.addLectureRecords(req);
      if (res.code == 200) {
        this.drawerShow = false;
        this.getList();
      } else {
        this.$message({
          type: "error",
          message: "新增失败"
        });
      }
    },
    async editInfo(info) {
      let req = Object.assign({}, info);
      let res = await this.$Http.editLectureRecords(req);
      if (res.code == 200) {
        this.drawerShow = false;
        this.getList();
      } else {
        this.$message({
          type: "error",
          message: "编辑失败"
        });
      }
    },
     // 导出数据
    async exportData() {
      let req = {
        organizationId: this.$store.getters.getUserInfo.schoolId,
        type:3
      };
      this.$Common.exportData(req, "exportLectureRecords", "授课记录", true);
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {
    this.getList();
  },
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped></style>
